module.exports = __webpack_public_path__ + "static/media/v3.05b47d8c.jpg";